import React, { Component } from 'react';
import { Button, Table, Form, Divider, DatePicker } from 'antd';
import axios from '../../service/index'
import './seeklessons.less'
const { RangePicker } = DatePicker;
class Userlist extends Component {

	constructor(props) {
		super(props)
		this.state = {
			visible: false,
			lableListData: [],
			phone: '',
			endTime: '',
			startTime: '',
			isHas: 0,
			sourceType: undefined,
			autoSyn: 0,
			total: 0,
			searchData: {
				pageNum: 1,
				pageSize: 10,
			},
			isTeacher: 2,
			labelName: '',
			allowClear: false,
			labelId: null,
			value: [],
			columns: [
				{
					title: '反馈内容',
					dataIndex: 'msg',
					key: 'msg',
					align: 'center'
				},
				{
					title: '求课时间',
					dataIndex: 'createTime',
					key: 'createTime',
					align: 'center'
				}
			]
		}
	}
	componentDidMount() {
		this.lableList()
	}
	lableList = () => {
		axios.post('feedbackController/getFeedbackList', {
			...this.state.searchData,
			startTime: this.state.startTime,
			endTime: this.state.endTime,
		}).then(res => {
			
			if (res.data.code === '200') {
				console.log(res.data)
				this.setState({
					lableListData: res.data.data.list,
					total: res.data.data.total
				})


			}
		})
	}
	exportData(){
		// window.location.href = `http://192.168.40.55:8686/video-wechat-manager/api/userController/export?endTime=${this.state.endTime}&startTime=${this.state.startTime}&autoSyn=${this.state.autoSyn}&isHas=${this.state.isHas}&isTeacher=${this.state.isTeacher}`
		axios.get(`feedbackController/export?endTime=${this.state.endTime}&startTime=${this.state.startTime}`,{responseType: 'blob'}).then(res =>{
			const link = document.createElement('a')
			let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
			link.style.display = 'none'
			link.href = URL.createObjectURL(blob)
			link.setAttribute('download', '用户求课.xlsx')
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		})
	}
	render() {
		const { lableListData, columns, total, value } = this.state
		const pagination = {
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.lableList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.lableList(searchData)
			},
		}
		return (
			<div className="seeklessons">
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>用户管理</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div style={{display: 'flex',flexWrap: 'wrap'}}>
						<RangePicker value={value} onChange={(date, dateString)=>{
							console.log(date, dateString);
							this.setState({
								value: date,
									startTime: dateString[0],
									endTime: dateString[1]
							})
						}} />
						<Button className='my-button-primary' style={{ marginLeft: '20px' }} type='primary' onClick={() => {
							this.lableList()
						}}>搜索</Button>
						<Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
							this.setState({
								value: undefined,
									startTime: '',
									endTime: '',
									searchData: {
										pageSize: 10,
										pageNum: 1,	
									},
									sourceType: undefined
							},()=>{
								this.lableList()
							})
						}}>重置</Button>
					</div>
					<div>
					<Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
						this.exportData()	
						}}>导出</Button>
					</div>
				</div>
				<Table pagination={pagination} dataSource={lableListData} columns={columns} rowKey={record => record.id} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}/>
			</div>
		)
	}

};

export default Form.create()(Userlist)